import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { config } from '../../../../../../environments/config';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { FileUploadModule } from 'primeng/primeng';

import { CustomerGuideHseDocumentsService } from '../../../service/customer-guide-hse-document/customer-guide-hse-document.service';

@Component({
  selector: 'app-customer-guides-attach-documentation',
  templateUrl: './customer-guides-attach-documentation.component.html',
  styleUrls: ['./customer-guides-attach-documentation.component.scss']
})
export class CustomerGuidesAttachDocumentationComponent implements OnInit {
  @Input() customer_guide_id: number;
  @Input() doc_customer_guide_input: any[];
  @Input() list_customer_guide_document_id: number;
  @Input() list_customer_guide_document_name: string;
  @Output() updateDocuments: EventEmitter<boolean> = new EventEmitter<boolean>();

  public apiUrl = config.API_ROOT;
  public loading_upload: boolean = false;
  public doc_customer_guide: any[] = [];
  public uploadedAttachment: any[] = [];
  public prewiewFileAttachment: any[] = [];
  public promiseAttachment: Promise<any>;
  
  @ViewChild('fileUpload') fileUpload: any;

  constructor(
    public hasPermissionService: HasPermissionService,
    private notificationsService: NotificationsService,
    public customerGuideHseDocumentsService: CustomerGuideHseDocumentsService,
    public translate: TranslateService,
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.doc_customer_guide = [];
    this.doc_customer_guide_input.forEach(element=>{
      if (element.list_customer_guide_hse_id == this.list_customer_guide_document_id)
        this.doc_customer_guide.push(element);
    });
  }

  public onUploadFileDocumentCustomerGuide(event: any, item) {
    console.log (event);
    for (const file of event.srcElement.files) {
      this.uploadedAttachment[item.id] = file
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewFileAttachment[item.id] = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public addAttachmentDocument(event) {
    this.loading_upload = true;
    this.translate.get('uploading').subscribe((res: string) => {
      this.notificationsService.growlNotify('info', res + '...');
    });
    let uploadedAttachment = [];
    for (const file of event.files) {
      uploadedAttachment.push(file);
    }
    
    this.promiseAttachment = this.customerGuideHseDocumentsService.addAttachmentDocumentCustomerGuide(uploadedAttachment, this.customer_guide_id, this.list_customer_guide_document_id).toPromise().then(
      response => {
        this.fileUpload.clear();
        this.loading_upload = false;
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
        });
        this.updateDocuments.emit(true);
      },
      error => {
        this.loading_upload = false;
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );
  }

  public gotoAttachmentDocumentCustomerGuide(id) {
    window.open(this.apiUrl + '/documents-customer-guide/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  public deleteAttachmentDocumentCustomerGuide(id) {
    this.promiseAttachment = this.customerGuideHseDocumentsService.deleteAttachmentDocumentCustomerGuide(id).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
          
        });
        this.updateDocuments.emit(true);
        // this.showDocumentationDialog(this.selectCitation,this.selectCitationType);
        // const index = this.findElement(this.uploadedAttachment, id);
        // if (index > -1) {
        //   this.uploadedAttachment.splice(index, 1);
        // }                
        // console.log(this.uploadedAttachment);
      },
      error => {
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );
  }

  public findElement (list, search) {
    let find = -1;
    let itera = 0;
    list.forEach(element => {
      if (element.id === search) {
        find = itera;
      }
      itera++;
    });
    return find;
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/customer-guides/customer-guides-attach-documentation/customer-guides-attach-documentation.component.ts